module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAATdJREFUOE/tk0tKA2EQhKv+RMckPkEJCILgLBMRstFsBT2BNxC8hCdw42MliAtPIbgQL+BrTFZGEUERgpBIMsY8/hKFBHXGLMzW3nb3R9NVRfRYbO8/Tmbio7G3ORL9YUxJjcoLLieKeR/Tc8O8uyh9zHUAVTd9BGAQwmcjUMQYwVcrHNAom7i+WvsJ8OJxLtDzqqEXZDJ9tXL9HIZbsJiPFbzVIMCxWebzld8Afrl+Zgy3/wE9/KBWrp/CcCf0ib6bKhA4EUyS0sAXJQjinuKINZoC7CYVWQzI6LupmpFZt9Q4yEgHYGWN4UNLaEaNjlsWaYLLYYAiEV0RWvsC/DAvGOFJ1B6BpVghFzDSIYGkhOdu+SIxI6uNxG1u95sT5bpOwzqzTUSdboAWVRq68XLtmU6Y/prqd9ifxxHbzjnxAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/kc.png
// module id = FwFL
// module chunks = 96